// extracted by mini-css-extract-plugin
module.exports = {"TrainingRoom":"TrainingRoom_TrainingRoom__xQvjW"};